var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{staticClass:"img-fluid",staticStyle:{"width":"75px"},attrs:{"src":require("../../../../assets/images/logo/efatura.png")},on:{"click":function($event){return _vm.EBelge()}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }